import { AlertOptions } from '../models';

export const DefaultAlertOptions: AlertOptions = {
    fadeTime: 5000,
    dismissable: true,
    persist: true
};
